import { useFormikContext } from 'formik';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../../../../../components/Checkbox/Checkbox';
import Input from '../../../../../../components/Input/Input';
import { useAppSelector } from '../../../../../../reduxService/hooks';
import { EConversionImperialToSI, EConversionSIToImperial, conversionLabel, convertTo } from '../../../../../conversion';
import { UnitOfMeasure } from '../../../../../enum/project';
import { selectProjectInfo } from '../../../../../store/projectInfo/projectInfoSlice';
import { roundToFour, roundToTwo } from '../../Geometry/utils';
import { CheckForAllMats } from '../MaterialDataCheckboxes/CheckForAllMats';
import { IFormikForm } from '../ModalMaterial/FormikMaterial';
import Natural from './Natural';

type Props = {};

export const RipRap = (props: Props) => {
    const { t } = useTranslation();
    const { values, setFieldValue } = useFormikContext<IFormikForm>();
    const [thickness, setThickness] = React.useState<number>(values[values.sectorChannel].thickness ?? 0);
    const [geoFilter, setGeoFilter] = React.useState<boolean>(values[values.sectorChannel].material?.isGeotextileFilter || false);
    const projectInfo = useAppSelector(selectProjectInfo);
    let isImperial = projectInfo?.data?.unitOfMeasure == UnitOfMeasure.Imperial;
 
    const handleRiprapChange = (rockD50: number) => {
        rockD50 = isImperial ? convertTo(rockD50, EConversionImperialToSI.in_to_m) : rockD50;
        let _allowedShearStress = 0.047 * (26000 - 10000) * rockD50;
        let _thickness = rockD50 * 1.5;
        setThickness(_thickness);
        setFieldValue(`${values.sectorChannel}.allowShearStress`, _allowedShearStress);
        setFieldValue(`${values.sectorChannel}.thickness`, _thickness);
        setFieldValue(`${values.sectorChannel}.material.isGeotextileFilter`, geoFilter);
        setFieldValue(`${values.sectorChannel}.rockD50`, rockD50);
    };

    return (
        <>
            <div className='d-flex gap-3'>
                <CheckForAllMats />

                <Checkbox
                    title={t('material_geotextile')}
                    name='isGeotextileFilter'
                    defaultChecked={values[values.sectorChannel].material?.isGeotextileFilter}
                    onChange={e => {
                        setGeoFilter(e.target.checked);
                        setFieldValue(`${values.sectorChannel}.material.isGeotextileFilter`, e.target.checked);
                    }}
                />
            </div>
            <div className='d-flex justify-content-between mt-2 gap-2'>
                <Input
                    type='number'
                    title={t('material_rock', { unit_measure: conversionLabel.m_in[projectInfo.data?.unitOfMeasure as number] })}
                    name='rockD50'
                    defaultValue={isImperial ? convertTo(values[values.sectorChannel].rockD50 ?? 0, EConversionSIToImperial.m_to_in) : values[values.sectorChannel].rockD50 ?? 0}
                    onChange={e => handleRiprapChange(parseFloat(e.target.value))}
                />
                <Input
                    type='number'
                    title={t('material_thickness_measure', { unit_measure: conversionLabel.m_in[projectInfo.data?.unitOfMeasure as number] })}
                    name='thickness'
                    value={isImperial ? roundToFour(convertTo(thickness ?? 0, EConversionSIToImperial.m_to_in)) : roundToFour(thickness ?? 0)}
                    disabled
                />
            </div>
            <Natural hideForALl />
        </>
    );
};
